var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    _vm._g(
      {
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "16",
          fill: "none"
        }
      },
      _vm.$listeners
    ),
    [
      _c("path", {
        attrs: {
          fill: "#E1E3E7",
          d:
            "M19.935 15.476H1.815a1.775 1.775 0 0 1-1.277-.525A1.83 1.83 0 0 1 0 13.663V2.813a1.854 1.854 0 0 1 .538-1.288A1.798 1.798 0 0 1 1.815 1h18.12a1.775 1.775 0 0 1 1.277.525 1.831 1.831 0 0 1 .538 1.288V13.67c-.006.484-.2.946-.54 1.284-.34.338-.799.526-1.275.522ZM7.5 5.442c0-.35-.263-.633-.585-.633h-4.08c-.322 0-.585.282-.585.633v2.545c0 .35.263.632.585.632h4.08c.322 0 .585-.282.585-.632V5.442Z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#000",
          d:
            "M18.75 12.429H16.5c-.488 0-.75-.229-.75-.762 0-.534.262-.762.75-.762h2.25c.488 0 .75.228.75.762 0 .533-.262.762-.75.762Zm-4.5 0H12c-.488 0-.75-.229-.75-.762 0-.534.262-.762.75-.762h2.25c.488 0 .75.228.75.762 0 .533-.262.762-.75.762Zm-4.5 0H7.5c-.487 0-.75-.229-.75-.762 0-.534.263-.762.75-.762h2.25c.488 0 .75.228.75.762 0 .533-.262.762-.75.762Zm-4.5 0H3c-.487 0-.75-.229-.75-.762 0-.534.263-.762.75-.762h2.25c.487 0 .75.228.75.762 0 .533-.263.762-.75.762Z",
          opacity: ".3"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }